import { hCreateHttpRequestClient } from '@onify/helix-core';
import packageJson from '../../package.json';
import { getHelixConfig } from '../config/helix.config.js';

const initialHelixConfig = getHelixConfig();

const helixHttpRequestClient = hCreateHttpRequestClient({
  apiBaseUrl: import.meta.env.HELIX_API_URL,
  onifyHubAPIPath: import.meta.env.ONIFY_HUB_API_PATH,
  appVersion: packageJson.version,
  enableLoginRedirect: true,
  loginRedirectConfig: {
    loginUrl: initialHelixConfig.loginUrl,
    logoutUrl: initialHelixConfig.logoutUrl,
  },
});

const localAuthToken = import.meta.env.VITE_LOCAL_API_TOKEN;
const isProduction = import.meta.env.PROD;

helixHttpRequestClient.updateApiClientConfig({
  credentials: 'include',
  hooks: {
    beforeRequest: [
      ...(localAuthToken && !isProduction
        ? [
            ({ request }) => {
              request.headers.set('Authorization', `Bearer ${localAuthToken}`);
            },
          ]
        : []),
    ],
  },
});

export function applyHelixLoginRedirectConfig(helixConfig) {
  helixHttpRequestClient.updateLoginRedirectConfig({
    loginUrl: helixConfig.loginUrl,
    logoutUrl: helixConfig.logoutUrl,
  });
}

export { helixHttpRequestClient };
